var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Search Client Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-search'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchapproval),
      expression: "searchapproval"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "searchapproval",
      "id": "searchapproval",
      "placeholder": "Search Client or Company Name"
    },
    domProps: {
      "value": (_vm.searchapproval)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchapproval = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchapprovalitem
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.approvalListing), function(val, index) {
    return [_c('tr', {
      class: {
        opened: _vm.opened.includes(val.ClientMasterID)
      }
    }, [_c('td', [(_vm.opened.includes(val.ClientMasterID) == false) ? _c('i', {
      staticClass: "fa fa-chevron-right",
      staticStyle: {
        "font-size": "12px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getClientInfo(val)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.opened.includes(val.ClientMasterID) == true) ? _c('i', {
      staticClass: "fa fa-chevron-down",
      staticStyle: {
        "font-size": "12px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getClientInfo(val)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(val.CompanyActualBusinessName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(val.CompanyName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("In-Active")]), _vm._v(" "), (val.emailid == _vm.useremail) ? _c('td', {
      staticClass: "text-center link",
      attrs: {
        "scope": "row"
      }
    }, [(_vm.opened.includes(val.ClientMasterID) == false) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.getClientInfo(val)
        }
      }
    }, [_vm._v(_vm._s('Pending for' + ' ' + 'Approve'))]) : _vm._e(), _vm._v(" "), (_vm.opened.includes(val.ClientMasterID) == true) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.getClientInfo(val)
        }
      }
    }, [_vm._v(_vm._s('Pending for' + ' ' + 'Approve'))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (val.emailid != _vm.useremail) ? _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s('Processing'))]) : _vm._e()]), _vm._v(" "), (_vm.opened.includes(val.ClientMasterID)) ? _c('tr', [_c('vue-element-loading', {
      attrs: {
        "spinner": "line-scale",
        "color": "#FF6700",
        "active": _vm.isLoading1
      },
      on: {
        "update:active": function($event) {
          _vm.isLoading1 = $event
        }
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": 12
      }
    }, [_c('br'), _vm._v(" "), _c('b-card', {
      staticStyle: {
        "margin": "15px",
        "-webkit-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "-moz-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)"
      }
    }, [_c('div', [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('th', {
      attrs: {
        "width": "25%",
        "colspan": "4"
      }
    }, [_vm._v("Company Basic information")])]), _vm._v(" "), _c('tr', {
      staticClass: "active"
    }, [_c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_c('span', [_c('b', [_vm._v("Actual Business Name ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.CompanyActualBusinessName) + " ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_c('span', [_c('b', [_vm._v("Name ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.CompanyName))])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "25%",
        "colspan": "2"
      }
    }, [_c('span', [_c('b', [_vm._v("website ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.ClientURL) + " ")])])]), _vm._v(" "), _c('tr', [_c('th', {
      attrs: {
        "width": "25%",
        "colspan": "4"
      }
    }, [_vm._v("Company Address")])]), _vm._v(" "), _c('tr', {
      staticClass: "active"
    }, [_c('td', [_c('span', [_c('b', [_vm._v("City ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.ClientCity))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("State ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.ClientState))])]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', [_c('b', [_vm._v("Pincode")]), _vm._v(": " + _vm._s(_vm.clientInfoData.ClientPinCode) + " ")])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#91949721"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('span', [_c('b', [_vm._v("Address ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.ClientAddress) + " ")])])]), _vm._v(" "), _c('tr', [_c('th', {
      attrs: {
        "colspan": "4",
        "width": "25%"
      }
    }, [_c('span', [_c('b', [_vm._v("Business Configuration")])])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#91949721"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Route Mode ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.RouteMode))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Average Weight of  Shipment in Kg ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.AverageWeightofShipment))])]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', [_c('b', [_vm._v("Average Cost of Shipment ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.AverageCostofShipment))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("Billing Cycle ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.BillingCycle))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Industry ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.Industry) + " ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v("Type Of Ownership ")]), _vm._v(":  " + _vm._s(_vm.clientInfoData.TypeOfOwnership))])]), _vm._v(" "), _c('tr', [_c('th', {
      attrs: {
        "colspan": "4",
        "width": "25%"
      }
    }, [_c('span', [_c('b', [_vm._v("Business Finance Details")])])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#91949721"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Business Configuration ")]), _vm._v(": " + _vm._s(_vm.BusinessConfig))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Account Name ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.AccountName))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Bank Branch  ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.ClientBankBranchName))])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#91949721"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Pickup Model Type ")]), _vm._v(":\n                              "), (_vm.clientInfoData.IsVendorPickup == true) ? _c('span', [_vm._v("Vendor")]) : _vm._e(), _vm._v(" "), (_vm.clientInfoData.IsVendorPickup == true &&
      _vm.clientInfoData.IsWareHousePickup == true) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" "), (_vm.clientInfoData.IsWareHousePickup == true) ? _c('span', [_vm._v("Warehouse")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('span', [_c('b', [_vm._v("Delivery Service Types ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.DeliveryServiceType))])])]), _vm._v(" "), _c('tr', [_c('th', {
      attrs: {
        "colspan": "4",
        "width": "25%"
      }
    }, [_c('span', [_c('b', [_vm._v("Operation Details")])])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#91949721"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Api Integration Required ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.APIIntegrationRequired == true ? 'Yes' : 'No'))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Shipment To Be Processes API ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.ShipmentTobeProcessesAPI == 1 ? 'Yes' : 'No'))])]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', [_c('b', [_vm._v("Shipment To Be Processes Soft-Data ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.ShipmentTobeProcessesSoftData == 1 ? 'Yes' : 'No'))])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#91949721"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Average Weight of  Shipment in Kg ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.AverageWeightofShipment))])]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('span', [_c('b', [_vm._v("Average Cost of Shipment ")]), _vm._v(": " + _vm._s(_vm.clientInfoData.AverageCostofShipment))])])]), _vm._v(" "), _c('tr', [_c('th', {
      attrs: {
        "colspan": "4",
        "width": "25%"
      }
    }, [_c('span', [_c('b', [_vm._v("GST Details")])])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('b-card', {
      staticStyle: {
        "margin": "15px",
        "-webkit-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "-moz-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "text-primary"
    }, [_c('th', {
      staticClass: "text-center tableheader"
    }, [_c('b', [_vm._v("# ")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('b', [_vm._v("Registration Number ")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('b', [_vm._v("Registration State  ")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('b', [_vm._v("Download File ")])])])]), _vm._v(" "), _c('tbody', [(_vm.gstDetailes.length == 0) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "4",
        "align": "center"
      }
    }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.gstDetailes), function(val, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(val.RegistrationNumber))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(val.RegistrationState))]), _vm._v(" "), _c('td', {
        staticClass: "text-center link",
        attrs: {
          "scope": "row"
        },
        on: {
          "click": function($event) {
            _vm.DownloadFile(val.FilePath)
          }
        }
      }, [_vm._v("Download")])])
    })], 2)])])], 1)]), _vm._v(" "), _c('tr', [_c('th', {
      attrs: {
        "colspan": "4",
        "width": "25%"
      }
    }, [_c('span', [_c('b', [_vm._v("SPOC Details")])])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('b-card', {
      staticStyle: {
        "margin": "15px",
        "-webkit-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "-moz-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "text-primary"
    }, [_c('th', {
      staticClass: "text-center tableheader"
    }, [_c('b', [_vm._v("# ")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('b', [_vm._v("Name")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('b', [_vm._v("Contact Email")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('b', [_vm._v("Contact Number ")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('b', [_vm._v("Contact Type ")])])])]), _vm._v(" "), _c('tbody', [(_vm.gstDetailes.length == 0) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "4",
        "align": "center"
      }
    }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.spocDetails), function(val, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(val.Name))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(val.Email))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(val.ContactNo))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(val.Type))])])
    })], 2)])])], 1)])])]), _vm._v(" "), _c('br'), _vm._v(" "), (val.emailid == _vm.useremail) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.openPopupForapprove(_vm.approve = 'approve')
        }
      }
    }, [_vm._v("Approve")]), _vm._v("   \n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.openPopupForapprove(_vm.approve = 'reject')
        }
      }
    }, [_vm._v(" Reject")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    })]) : _vm._e(), _vm._v(" "), _c('br')])])], 1)], 1) : _vm._e()]
  })], 2)]), _c('br'), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-dialog modal-sm"
    },
    on: {
      "ok": function($event) {
        _vm.changepopupStatusFlag = false
      }
    },
    model: {
      value: (_vm.changepopupStatusFlag),
      callback: function($$v) {
        _vm.changepopupStatusFlag = $$v
      },
      expression: "changepopupStatusFlag"
    }
  }, [_c('b-card', [(_vm.approvalstatus1 == 'approve') ? _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "margin-left": "48px"
    }
  }, [_vm._v(" Do you want to Approve ?")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.cancelmodal
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.approvalstatus1 == 'reject') ? _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "margin-left": "48px"
    }
  }, [_vm._v(" Do you want to Reject ?")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.cancelmodal
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.approvalstatus1 == 'approve') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "position": "relative",
      "right": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeClientBusinessStatus(_vm.approve = 'approve')
      }
    }
  }, [_vm._v("Approve")]), _vm._v("   \n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [(_vm.approvalstatus1 == 'reject') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "58px"
    }
  }, [_vm._v("\n                 Select Reject Reason\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.approvalstatus1 == 'reject') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectReson),
      expression: "rejectReson"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('rejectReson')
    },
    staticStyle: {
      "max-width": "90%"
    },
    attrs: {
      "id": "rejectReson",
      "name": "rejectReson"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rejectReson = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Reason--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Client Details Not Correct")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Need to verify Client")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Client contract is no long with Xbees")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("other")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rejectReson')),
      expression: "errors.has('rejectReson')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Reject Reason.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.approvalstatus1 == 'reject' && _vm.rejectReson == 4) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "77px"
    }
  }, [_vm._v("\n                  Add Comment\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.approvalstatus1 == 'reject' && _vm.rejectReson == 4) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commnet),
      expression: "commnet"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'error': _vm.errors.has('commnet')
    },
    staticStyle: {
      "margin-left": "31px",
      "width": "185px"
    },
    attrs: {
      "placeholder": "Enter Comment",
      "name": "commnet",
      "id": "commnet"
    },
    domProps: {
      "value": (_vm.commnet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commnet = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('commnet')),
      expression: "errors.has('commnet')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Comment.")])])]) : _vm._e(), _vm._v(" "), (_vm.approvalstatus1 == 'reject') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "81px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Reject")])])]) : _vm._e()])])])], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Approval List")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("# ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Name ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Company Name ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Approval Status")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-605b629b","hasScoped":true}!./src/views/components/cargoclient/approvalflow/approvalflow-tab/approval/approval.component.html
// module id = 545
// module chunks = 3